<div class="modal fade" id="elimination-import-modal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    Import from rankings
                </h5>

                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>

            <div class="modal-body">
                <div class="mb-3">
                    <label for="input-entries-per-table" class="form-label">Imported entries per table</label>
                    <input type="number" class="form-control" id="input-entries-per-table">
                </div>
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="input-weighted-import" checked>
                    <label class="form-check-label" for="input-weighted-import">Weigh by total score</label>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" id="btn-elimination-dialog-submit">
                    Import
                </button>
            </div>

        </div>
    </div>
</div>